var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcelSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2H9V.5a.499.499 0 0 0-.592-.491l-8 1.5A.499.499 0 0 0 0 2v11a.5.5 0 0 0 .408.491l8 1.5A.497.497 0 0 0 9 14.5V13h6.5a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5zM6.829 9.876a.498.498 0 0 1-.705-.047L4.67 8.168l-1.275 1.64a.502.502 0 0 1-.891-.246.501.501 0 0 1 .101-.369l1.394-1.792-1.375-1.572a.5.5 0 1 1 .753-.658l1.248 1.426 1.481-1.904a.5.5 0 1 1 .789.615l-1.6 2.056 1.581 1.807a.5.5 0 0 1-.047.705zM15 12H9v-1h1.5a.5.5 0 0 0 0-1H9V9h1.5a.5.5 0 0 0 0-1H9V7h1.5a.5.5 0 0 0 0-1H9V5h1.5a.5.5 0 0 0 0-1H9V3h6v9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm0 2h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm0 2h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1zm0 2h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelSvg);
export default __webpack_public_path__ + "static/media/Excel-SVG.673cf6637f1d0df87c7a02e73241b219.svg";
export { ForwardRef as ReactComponent };